import type { accountMenu as en } from '@/i18n/locales/en/accountMenu';
import type { Translation } from '@/i18n/types';

export const accountMenu: Translation<typeof en> = {
  trigger: 'Compte',
  viewProfile: 'Voir le profil',
  roles: {
    admin: 'Administrateur de la plateforme',
    companyAdmin: 'Administrateur d’entreprise',
    departmentAdmin: 'Administrateur/coach de département',
  },
  company: {
    label: 'Entreprise',
    switchTo: 'Passer à {{name}}',
  },
  accounts: {
    label: 'Autres comptes',
    switchTo: 'Passer à {{name}}',
    addAnother: 'Se connecter avec un autre compte',
  },
  manage: 'Gestion',
  settings: 'Profil de l’entreprise',
  language: 'Langue',
  theme: {
    label: 'Thème',
    light: 'Clair',
    dark: 'Sombre',
    system: 'Système',
  },
  signOut: 'Se déconnecter',
  signOutAll: 'Se déconnecter de tous les comptes',
};
